import React, { useState } from 'react';
import fremtidensmad from '../../images/fremtidensmad.jpg';
import { useNavigate } from 'react-router-dom';

const stockSymbols = [
  {symbol: 'UL', name: 'Unilever' },
  {symbol: 'ORK.OL', name: 'Orkla' },
  {symbol:'NSIS-B.CO', name: 'Novonesis'},
  { symbol: 'BYND', name: 'Beyond Meat' },
  { symbol: 'OTLY', name: 'Oatly' },
  { symbol: 'K', name: 'Kellogg' },
  { symbol: 'TSN', name: 'Tyson Foods' },
  { symbol: 'CPB', name: 'Campbell Soup' },
  { symbol: 'GIS', name: 'General Mills' },
  { symbol: 'HRL', name: 'Hormel Foods' },
  { symbol: 'KHC', name: 'Kraft Heinz' },
  { symbol: 'MKC', name: 'McCormick' },
  { symbol: 'PEP', name: 'PepsiCo' },
  { symbol: 'SJM', name: 'JM Smucker' },
  { symbol: 'CAG', name: 'Conagra Brands' },
  { symbol: 'ADM', name: 'Archer-Daniels-Midland' },
  { symbol: 'COST', name: 'Costco' },
  { symbol: 'WMT', name: 'Walmart' },
  { symbol: 'TGT', name: 'Target' },
  { symbol: 'KR', name: 'Kroger' },
  { symbol: 'CASY', name: 'Casey\'s General Stores' },
  { symbol: 'BJ', name: 'BJ\'s Wholesale Club' },
];

function FintechCard01() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [stocks, setStocks] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  const handleCardClick = async () => {
    setLoading(true);
    setIsModalOpen(true);
    try {
      const symbolsToFetch = stockSymbols.map(stock => stock.symbol);
      console.log('Fetching symbols:', symbolsToFetch);
      
      // Make individual requests for each symbol
      const stockPromises = symbolsToFetch.map(async symbol => {
        const response = await fetch(
          `https://investorverden.onrender.com/api/stocks?q=${symbol}`
        );
        if (!response.ok) throw new Error(`Failed to fetch ${symbol}`);
        return response.json();
      });
  
      const results = await Promise.all(stockPromises);
      console.log('Raw results:', results);
  
      const processedStocks = results
        .filter(result => result && result.stockData)
        .map(result => {
          const sd = result.stockData;
          const symbol = sd.symbol;
          const matchingSymbol = stockSymbols.find(s => s.symbol === symbol);
  
          return {
            logo: sd.logo_url || '',
            name: matchingSymbol?.name || sd.shortName || symbol,
            price: sd.regularMarketPrice?.toFixed(2) || '0.00',
            changePercent24h: sd.regularMarketChangePercent?.toFixed(2) || '0.00',
            isPositive: parseFloat(sd.regularMarketChangePercent) > 0,
            marketCap: sd.marketCap ? 
              (sd.marketCap / 1000000000).toFixed(2) + 'B' : 
              'N/A',
            currency: sd.currency || 'USD'
          };
        });
  
      console.log('Processed stocks:', processedStocks);
      setStocks(processedStocks);
  
    } catch (error) {
      console.error('Error:', error);
      setStocks([]);
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <div
        className="flex flex-col col-span-full sm:col-span-6 xl:col-span-3 bg-white dark:bg-gray-800 shadow-sm rounded-xl cursor-pointer"
        onClick={handleCardClick}
      >
        <div className="px-5 pt-5">
          <header>
            <h3 className="text-sm font-semibold text-gray-500 uppercase mb-1">
              <span className="text-gray-800 dark:text-gray-100">Fremtidens mad</span>
            </h3>
          </header>
        </div>
        <div className="grow">
          <img src={fremtidensmad} alt="Fremtidens mad" className="w-full h-auto rounded-b-xl" />
        </div>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
          <div
            className="bg-white dark:bg-gray-800 p-5 rounded-lg shadow-lg w-full max-w-4xl"
            style={{ maxHeight: '80vh', overflowY: 'auto' }}
          >
            <h2 className="text-l font-semibold mb-4 dark:text-white">Fremtidens mad</h2>
            <h5 className="dark:text-gray-300">
              Selskaber med en mission om at reducere CO2-aftrykket fra fødevareindustrien og skabe
              sundere fødevarer.
            </h5>
            <br />

            {loading ? (
              <div className="flex justify-center items-center h-48">
                <svg
                  className="animate-spin h-10 w-10 text-violet-500"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v8H4z"
                  ></path>
                </svg>
              </div>
            ) : (
              <table className="w-full text-left">
                <thead>
                  <tr className="border-b">
                    <th className="px-2 py-1">Logo</th>
                    <th className="px-2 py-1">Selskab</th>
                    <th className="px-2 py-1">I dag</th>
                    <th className="px-2 py-1">Børsværdi</th>
                  </tr>
                </thead>
                <tbody>
                  {stocks.map((stock, index) => (
                    <tr key={index} className="border-b">
                      <td className="px-2 py-2">
                        <img src={stock.logo} alt={stock.name} className="w-6 h-6" />
                      </td>
                      <td className="px-2 py-2">
                        {stock.name}: {stock.currency}
                      </td>
                      <td className={`px-2 py-2 ${stock.isPositive ? 'text-green-500' : 'text-red-500'}`}>
                        {stock.changePercent24h}%
                      </td>
                      <td className="px-2 py-2">{stock.marketCap}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            <button
              className="mt-4 px-4 py-2 bg-violet-500 text-white rounded"
              onClick={closeModal}
            >
              Luk
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default FintechCard01;